import styled from "@emotion/styled";
import { RichTextStyle } from "../RichText";
var Section = /*#__PURE__*/ styled("section", {
    target: "e1msfyt90"
})("padding-top:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";display:", function(param) {
    var isHidden = param.isHidden;
    return isHidden ? "none" : "block";
}, ";color:", function(param) {
    var textStyle = param.textStyle, theme = param.theme;
    return textStyle === RichTextStyle.Alternative ? theme.color.natural0 : theme.color.secondary100;
}, ";");
export { Section };
